import { render, staticRenderFns } from "./searchBar.vue?vue&type=template&id=19222e3b&scoped=true"
import script from "./searchBar.vue?vue&type=script&lang=js"
export * from "./searchBar.vue?vue&type=script&lang=js"
import style0 from "./searchBar.vue?vue&type=style&index=0&id=19222e3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19222e3b",
  null
  
)

export default component.exports